import {
  Actions,
  Box,
  Button,
  Heading,
  IconPositive,
  Stack,
  Text,
} from 'braid-design-system';

import { useLogin } from '#src/hooks/auth.tsx';

interface AccountSetupSuccessProps {
  organizationId: string;
}

export const AccountSetupSuccess = ({
  organizationId,
}: AccountSetupSuccessProps) => {
  const { login } = useLogin();

  return (
    <Stack space="large" align="center">
      <Box style={{ width: '80px', height: '80px' }}>
        <IconPositive size="fill" tone="positive" />
      </Box>
      <Heading level="4">Account creation complete!</Heading>
      <Text>Your account has been created successfully.</Text>

      <Actions>
        <Button
          tone="brandAccent"
          onClick={() => {
            login({
              organization: organizationId,
              returnTo: '/manage',
            });
          }}
        >
          Log in and set up MFA
        </Button>
      </Actions>
    </Stack>
  );
};
